import { RegisterOptions } from "@electron-types/push-notification";
import { createElectronPlugin } from "./electron-plugin.util";

export { RegisterOptions };

interface PushNotificationPlugin {
    register: (options: RegisterOptions) => Promise<string>;
}

const PushNotificationElectron = createElectronPlugin<PushNotificationPlugin>('PushNotification');

export default PushNotificationElectron;
